import { ChainId } from '@repo/web3'

export const SUPPORTED_CHAINS = [
  ChainId.Mainnet,
  ChainId.Optimism,
  ChainId.Unichain,
  ChainId.Polygon,
  ChainId.Worldchain,
  ChainId.Hyperevm,
  ChainId.Base,
  ChainId.Arbitrum,
  ChainId.Katana,
  ChainId.Monad,
  ChainId.Stable,
  ChainId.Tempo
] as const
